import metrics from "@constants/metrics";
import React, { useState } from "react";
import { View } from "react-native";
import Svg, { Circle, Rect } from "react-native-svg";

const HomePageSkeleton = (props) => {
  const [show, setShow] = useState(true);
  return !show ? null : (
    <View {...props}>
      <Svg
        width={metrics.screenWidth}
        height={metrics.screenHeight}
        viewBox={`0 0 ${metrics.screenWidth} ${metrics.screenHeight}`}
      >
        <Circle cx="56" cy="48" r="32" fill="#ecebeb" />
        <Rect
          x="44"
          y="93"
          rx="5"
          ry="5"
          width="25"
          height="10"
          fill="#ecebeb"
        />
        <Rect
          x="557"
          y="222"
          rx="5"
          ry="5"
          width="220"
          height="10"
          fill="#ecebeb"
        />
        <Circle cx="147" cy="48" r="32" fill="#ecebeb" />
        <Rect
          x="134"
          y="93"
          rx="5"
          ry="5"
          width="25"
          height="10"
          fill="#ecebeb"
        />
        <Circle cx="238" cy="48" r="32" fill="#ecebeb" />
        <Rect
          x="225"
          y="93"
          rx="5"
          ry="5"
          width="25"
          height="10"
          fill="#ecebeb"
        />
        <Circle cx="330" cy="48" r="32" fill="#ecebeb" />
        <Rect
          x="317"
          y="93"
          rx="5"
          ry="5"
          width="25"
          height="10"
          fill="#ecebeb"
        />
        <Circle cx="420" cy="48" r="32" fill="#ecebeb" />
        {/* ShopInfoCard */}
        <Rect
          x="15"
          y="123"
          rx="10"
          ry="10"
          width={`${metrics.screenWidth - 30}`}
          height={164}
          fill="#ecebeb"
        />

        <Rect
          x="15"
          y="337"
          rx="10"
          ry="10"
          width={156}
          height={200}
          fill="#ecebeb"
        />
        <Rect
          x="191"
          y="337"
          rx="10"
          ry="10"
          width={156}
          height={200}
          fill="#ecebeb"
        />
        <Rect
          x="367"
          y="337"
          rx="10"
          ry="10"
          width={156}
          height={200}
          fill="#ecebeb"
        />
      </Svg>
    </View>
  );
};

export default HomePageSkeleton;
